import { getDeviceFingerprint } from "./fingerprint";

export function getDeviceFpHeaders(): Record<string, string> {
  try {
    const fp = localStorage.getItem("scribpost-dfp");
    if (fp) return { "x-device-fp": fp };
  } catch {}
  return {};
}

export async function apiFetch(url: string, options: RequestInit = {}): Promise<Response> {
  let fpHeaders = getDeviceFpHeaders();

  if (!fpHeaders["x-device-fp"]) {
    try {
      const fp = await getDeviceFingerprint();
      if (fp) fpHeaders = { "x-device-fp": fp };
    } catch {}
  }

  const existingHeaders = options.headers || {};

  return fetch(url, {
    ...options,
    headers: {
      ...fpHeaders,
      ...(existingHeaders as Record<string, string>),
    },
  });
}
